import { I18nProvider } from '../providers/I18nProvider';
import { Calculator } from './Calculator';

interface AppProps {
  currency?: string;
  locale?: string;
}

export function App(props: AppProps) {
  return (
    <I18nProvider locale={props.locale}>
      <Calculator currency={props.currency} />
    </I18nProvider>
  );
}
